import { render, staticRenderFns } from "./TinyImpactRater.vue?vue&type=template&id=1c0758c8&scoped=true&"
import script from "./TinyImpactRater.vue?vue&type=script&lang=js&"
export * from "./TinyImpactRater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0758c8",
  null
  
)

export default component.exports